import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { gsap, Expo } from 'gsap';

@Component({
    selector: 'app-close-button',
    templateUrl: './close-button.component.html',
    styleUrls: ['./close-button.component.scss']
})
export class CloseButtonComponent implements OnInit {
    @ViewChild('btnClose', { static: false }) btnClose: ElementRef
    closeButtonImg: string = 'assets/img/icons/close-black.png'


    constructor() { }

    ngOnInit(): void {
    }
    onCloseOver() {
        // if (this.isMobile) return;
        this.closeButtonImg = 'assets/img/icons/close-blue.png';
        gsap.to(this.btnClose?.nativeElement.getElementsByClassName('closeImg'), .5, { scale: .85, ease: Expo.easeOut });
        gsap.to(this.btnClose?.nativeElement.getElementsByClassName('closeLine'), .5, { width: 40, height: 40, ease: Expo.easeOut });

    }

    onCloseOut() {

        this.closeButtonImg = 'assets/img/icons/close-black.png';
        gsap.to(this.btnClose?.nativeElement.getElementsByClassName('closeImg'), .25, { scale: 1, ease: Expo.easeOut });
        gsap.to(this.btnClose?.nativeElement.getElementsByClassName('closeLine'), .25, { width: 'calc(100% - 4px)', height: 'calc(100% - 4px)', ease: Expo.easeOut });
    }
}
